export enum ENewQuestionModalStep {
  Question = 'question',
  Success = 'success',
  Error = 'error',
}

export interface INewQuestion {
  open: boolean;
  step: ENewQuestionModalStep;
  name: string | null;
  text: string;
  isAnonymous: boolean | null;
}
